import { Place, PublicLead } from "shared/topchef.types";


const locHallBackOfficeRecipient = 'contact@lochall.fr';


export interface FollowLeadButtonProps {
  loggedInPlace: Place,
  lead: PublicLead
  followLead: () => void;
}


const FollowLeadButton = (props: FollowLeadButtonProps) => {

  const followLeadAndDisplayEmail = async () => {

    props.followLead();

    const subject = `${props.loggedInPlace.name} se positionne sur un brief`;
    const body = `Bonjour,\n\n\nJe souhaite me positionner sur le brief avec l'identifiant '${props.lead.id}'.\n\n\n Cordialement, \n\n\n${props.loggedInPlace.name}`;
    const mailtoLink = `mailto:${locHallBackOfficeRecipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink, "_blank");
  }


  const followedLeadForPlaceThatAcceptsFees = (
      <button id="brief_position_request" className="btn btn-primary m-3" onClick={props.followLead} >Me positionner</button>
  );

  const followedLeadForPlaceThatDoNoAcceptsFees = (
    <>
      <button id="brief_position_request" className="btn btn-primary m-3" onClick={followLeadAndDisplayEmail} >Me positionner <sup>*</sup></button>
      <div><i>* Vous allez envoyer un email à Loc'Hall qui se chargera de traiter ce brief pour vous.</i></div>
    </>
  );

  if (props.loggedInPlace.acceptReward) {
    return followedLeadForPlaceThatAcceptsFees;
  }
  else {
    return followedLeadForPlaceThatDoNoAcceptsFees;
  }


}

export default FollowLeadButton;
